/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductListSkuProductItem
 */
export interface ProductListSkuProductItem {
    /**
     * SKU商品组成ID（上传图片时作为 entityId 使用）
     * @type {number}
     * @memberof ProductListSkuProductItem
     */
    id?: number;
    /**
     * SPU编码
     * @type {string}
     * @memberof ProductListSkuProductItem
     */
    spuCode?: string;
    /**
     * SKU编码
     * @type {string}
     * @memberof ProductListSkuProductItem
     */
    skuCode?: string;
    /**
     * 商品图片URL
     * @type {string}
     * @memberof ProductListSkuProductItem
     */
    imageUrl?: string;
    /**
     * 商品URL
     * @type {string}
     * @memberof ProductListSkuProductItem
     */
    productUrl?: string;
    /**
     * 单价
     * @type {number}
     * @memberof ProductListSkuProductItem
     */
    unitPrice?: number;
    /**
     * 颜色
     * @type {string}
     * @memberof ProductListSkuProductItem
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof ProductListSkuProductItem
     */
    size?: string;
    /**
     * 通关类目ID
     * @type {number}
     * @memberof ProductListSkuProductItem
     */
    ctmsItemId?: number;
    /**
     * 通关类目名称
     * @type {string}
     * @memberof ProductListSkuProductItem
     */
    ctmsItemName?: string;
    /**
     * 通关类目路径
     * @type {string}
     * @memberof ProductListSkuProductItem
     */
    categoryPath?: string;
    /**
     * 海关商品英文名
     * @type {string}
     * @memberof ProductListSkuProductItem
     */
    coProNmEn?: string;
    /**
     * 海关编码
     * @type {string}
     * @memberof ProductListSkuProductItem
     */
    coHsCode?: string;
    /**
     * 构成数量
     * @type {number}
     * @memberof ProductListSkuProductItem
     */
    productNumber?: number;
    /**
     * 是否可编辑（上架列表显示修改按钮，下架列表不显示按钮）
     * @type {boolean}
     * @memberof ProductListSkuProductItem
     */
    editable?: boolean;
}

/**
 * Check if a given object implements the ProductListSkuProductItem interface.
 */
export function instanceOfProductListSkuProductItem(value: object): value is ProductListSkuProductItem {
    return true;
}

export function ProductListSkuProductItemFromJSON(json: any): ProductListSkuProductItem {
    return ProductListSkuProductItemFromJSONTyped(json, false);
}

export function ProductListSkuProductItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductListSkuProductItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'spuCode': json['spuCode'] == null ? undefined : json['spuCode'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
        'productUrl': json['productUrl'] == null ? undefined : json['productUrl'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'ctmsItemId': json['ctmsItemId'] == null ? undefined : json['ctmsItemId'],
        'ctmsItemName': json['ctmsItemName'] == null ? undefined : json['ctmsItemName'],
        'categoryPath': json['categoryPath'] == null ? undefined : json['categoryPath'],
        'coProNmEn': json['coProNmEn'] == null ? undefined : json['coProNmEn'],
        'coHsCode': json['coHsCode'] == null ? undefined : json['coHsCode'],
        'productNumber': json['productNumber'] == null ? undefined : json['productNumber'],
        'editable': json['editable'] == null ? undefined : json['editable'],
    };
}

export function ProductListSkuProductItemToJSON(json: any): ProductListSkuProductItem {
    return ProductListSkuProductItemToJSONTyped(json, false);
}

export function ProductListSkuProductItemToJSONTyped(value?: ProductListSkuProductItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'spuCode': value['spuCode'],
        'skuCode': value['skuCode'],
        'imageUrl': value['imageUrl'],
        'productUrl': value['productUrl'],
        'unitPrice': value['unitPrice'],
        'color': value['color'],
        'size': value['size'],
        'ctmsItemId': value['ctmsItemId'],
        'ctmsItemName': value['ctmsItemName'],
        'categoryPath': value['categoryPath'],
        'coProNmEn': value['coProNmEn'],
        'coHsCode': value['coHsCode'],
        'productNumber': value['productNumber'],
        'editable': value['editable'],
    };
}

